import axios from "fetch-api/fetch-api";
import { IVehicle } from "interfaces/session/IVehicle";
import { validateVehicle } from "../../util/vehicle/validate-vehicle";
import { IRVehicleDetails, IVehicleDetails } from "../interfaces/garage-apis";

export function getVehicleFitmentOptions(vehicle: IVehicle, fitmentOptionName: string): Promise<IRVehicleDetails> {
  return new Promise((resolve, reject) => {
    if (!validateVehicle(vehicle)) {
      resolve({} as IRVehicleDetails);
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { fitmentOptions, ...selectedVehicle } = vehicle;
    axios.get<IVehicleDetails>("/vehicle-fitment-option-values", {
      params: {
        ...selectedVehicle,
        fitmentOptionName,
      },
    }).then(({ data }) => {
      const updatedData = {
        data: data.optionValues || [],
        nextAttribute: data.id,
        title: data.title,
      };

      resolve(updatedData);
    }).catch((e: any) => reject(e));
  });
}
